<template>
  <div>
    <div class="pull-right m-b-xs">
      <div class="btn-filter-group">
        <button
          class="btn"
          :class="{ 'btn-white': !show, 'btn-danger': show }"
          @click="toggleFilters()"
        >
          <span v-if="!show">Adicionar Filtros</span>
          <span v-if="show">Remover Filtros</span>
        </button>
        <slot name="extra-button-2" />
        <slot name="extra-button" />
        <slot name="create-button" />
      </div>
    </div>
    <div class="form-group">
      <label slot="items-per-page">
        Itens por página<slot name="items-per-page" />
        />
      </label>
    </div>
    <div class="filtros" :class="{ open: show }">
      <label>Filtros de Pesquisa</label>
      <slot name="filter-items" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterContainer',
  methods: {
    toggleFilters() {
      this.show = !this.show
    }
  },
  data() {
    return {
      show: false
    }
  }
}
</script>
